import { EventNameTypes, makeSegmentTrackCall } from 'client/javascript/analytics';

export const trackInteraction = (label, properties = {}) =>
  makeSegmentTrackCall(EventNameTypes.interaction, { label, ...properties });
